import { RETREAT, RETREAT_DONE, RETREAT_START, CHOOSE_BENCH_POSITION } from './constants';
import { isImmutable, fromJS, List } from 'immutable';

/** Starts choosing the energy to discard; with a bench position, the Pokémon to switch in is already chosen (dragged). */
export const retreatStart = (benchPosition = null) => ({
  type: RETREAT_START,
  payload: fromJS({ benchPosition }),
});

export const chooseBenchPosition = (energyAttachmentIds) => ({
  type: CHOOSE_BENCH_POSITION,
  payload: fromJS({ energyAttachmentIds: isImmutable(energyAttachmentIds) ? energyAttachmentIds : List() }),
});

export const retreat = (benchPosition) => ({
  type: RETREAT,
  payload: fromJS({ benchPosition }),
});

export const retreatDone = () => ({
  type: RETREAT_DONE,
});

